import { render, staticRenderFns } from "./ProgrammesList.vue?vue&type=template&id=0b183740&"
import script from "./ProgrammesList.vue?vue&type=script&lang=js&"
export * from "./ProgrammesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports